// maths.portll.net — per-task state chip for the Grown-Ups' dashboard.
//
// Four honest, non-school states, DERIVED from the family's own records
// (completions + hand-collected datasets) — see TaskListByStrand.deriveTaskState.
// Tone stays warm: a finished task is "Done ✓", and progress across the year is
// framed as "explored", never "passed / graded / assessed". These four string
// keys are the shared vocabulary the whole dashboard speaks.

import { Chip } from "./ui.jsx";

/** Canonical state keys — the single source both the chip and the derivation use. */
export const TASK_STATE = {
  NOT_STARTED: "notStarted",
  PLANNED: "planned",
  DATA: "data",
  DONE: "done",
};

// key → { label, tone } — tone names map onto the ui.jsx Chip tones.
export const TASK_STATE_META = {
  notStarted: { label: "Not started", tone: "neutral" },
  planned: { label: "Planned", tone: "sky" },
  data: { label: "Data to enter", tone: "accent" },
  done: { label: "Done ✓", tone: "ok" },
};

/** A small status pill for one task. `state` is one of TASK_STATE's values. */
export default function StateChip({ state = "notStarted", className }) {
  const meta = TASK_STATE_META[state] || TASK_STATE_META.notStarted;
  return (
    <Chip tone={meta.tone} className={className}>
      {meta.label}
    </Chip>
  );
}
